import React from 'react';

import Authenticated from "Components/Layouts/Authenticated";
import Networking from 'Components/Networking/Networking';

export default class NetworkingIndex extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render() {
        return (
            <Authenticated pageTitle="Networking" pageVideoHeader={"bupa-banner.mp4"} showRegBanner={false}>
                <img src="/images/headers/networking.png" className="hidden lg:block" />
                <div className="min-h-screen text-black">
                    <Networking
                        useGroups={true}
                        selectedMessageToType='App\Models\User'
                        selectedMessageToId={this.props.match?.params?.user}
                    />
                </div>
            </Authenticated>
        )
    }
}
